export default __webpack_public_path__ + "static/media/starofthesea.f154fbc8.jpg";